<script>
  import { afterUpdate, onMount, createEventDispatcher } from "svelte";
  import { Stack } from "creditdesign-svelte-components";
  import { FilterButton } from "nature-immersive-svelte-components";
  import Top12Grid from "./components/Top12Grid/index.svelte";
  import FullList from "./components/FullList/index.svelte";
  import FilterContainer from "./components/FilterContainer/index.svelte";
  import {
    filteredCompanies,
    selectedCategoryOne,
    selectedCategoryTwo,
    filterExpanded
  } from "./data/store.js";

  export let data;
  let { companies, categories } = data;
  let mounted = false;

  $: {
    if (!$filterExpanded) {
      selectedCategoryOne.set("");
      selectedCategoryTwo.set("");
    }
  }

  $: {
    if (!$selectedCategoryOne) {
      selectedCategoryTwo.set("");
    }
  }

  $: {
    if ($selectedCategoryOne) {
      selectedCategoryTwo.set("");
    }
  }

  const dispatch = createEventDispatcher();

  afterUpdate(() => {
    dispatch("update");
  });

  onMount(() => {
    mounted = true;
  });
</script>

<style>
  /* Used in Company and SelectedCompany components */
  :global(.raised-card) {
    position: relative;
    height: 100%;
    padding: var(--s0);
    overflow: hidden;
    border-color: var(--white-2);
    border-style: solid;
    border-width: 1px;
    box-shadow: 0 0.2em 0.25em -0.1em var(--white-2);
  }

  :global(.raised-card--no-shaddow) {
    box-shadow: none;
  }

  :global(.filter-button) {
    margin-left: 3px;
  }

  :global(.company-icon) {
    fill: var(--black-3);
  }

  :global(.company-icon__margin-right) {
    margin-right: 5px;
  }

  :global(.faux-block-link::before) {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    content: "";
  }

  :global(.raised-card:hover) {
    border-color: var(--white-3);
    box-shadow: 0 0.3em 0.25em -0.1em var(--white-3);
  }

  [role="region"] > p {
    margin: 0;
  }
</style>

<Stack stackSpace="var(--s4)">
  <Stack className="border-above" stackSpace="var(--s1)">
    <Stack stackSpace="var(--s-3)">
      <h2 id="the-12-finalists">The 12 Finalists</h2>
      <p>
        These firms rose to the top of the ranks on the basis of the quality of
        their science and the soundness of their business plans. Each company is
        described in depth in the accompanying profile.
      </p>
    </Stack>
    <Top12Grid companies="{companies.filter(e => e.status)}" />
  </Stack>

  <Stack className="border-above" stackSpace="var(--s1)">
    <Stack stackSpace="var(--s-3)">
      <h2 id="the-full-44">The Full 44</h2>
      <p>
        The judges selected not only 12 finalists but also 32 other university
        spin-offs — the Ones to Watch. All 44 companies are listed below. Click
        on the filter button to sort the companies by their areas of focus.
      </p>
    </Stack>

    {#if mounted}
      <FilterButton
        expanded="{$filterExpanded}"
        message="Filter list"
        expandedMessage="Remove filter"
        on:click="{() => filterExpanded.set(!$filterExpanded)}"
      />

      <FilterContainer expanded="{$filterExpanded}" {categories} />
    {/if}

    <div aria-live="polite">
      <p>
        {`${$filteredCompanies.length} compan${$filteredCompanies.length === 1 ? 'y' : 'ies'} shown in list.`}
      </p>
    </div>

    <FullList
      filteredCompanies="{$filteredCompanies}"
      selectedCategoryOne="{$selectedCategoryOne}"
      selectedCategoryTwo="{$selectedCategoryTwo}"
    />

  </Stack>

</Stack>
